import styled from 'styled-components';

export const Header = styled.div`
  background-color: #28a745;
  padding: 20px 0px;
  justify-content: center;
  color: white;
  font-size: 20px;
  height: 50px;
  text-align: center;
`;

export const Bloco = styled.div`
  margin: 20px auto;
  width: 98%;
  min-width: 200px;
  height: 500px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  margin: 20px auto;
  background: white;
  border-radius: 8px;
  border: solid 2px #28a745;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  text-align: center;
`;